import React, { Component, PropTypes } from 'react';
import PageHeader from '../shared/PageHeader';
import DetailHeader from '../shared/DetailHeader';
import MyCollectionToolbar from './MyCollectionToolbar';
import Icon from '../shared/Icon';
import MyCollectionPersons from './MyCollectionPersons';
import MyCollectionObjects from './MyCollectionObjects';
import localize from '../../localize';
import {
    getCurrentLanguage,
    clearMyCollection,
    removeFromMyCollection,
    isMyCollectionEmpty,
    getMyCollection,
} from '../../localData';

class MyCollection extends Component {

    static propTypes = {
        store: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
    };

    toggleEditMode = () => {
        this.props.relay.setVariables({
            isEditMode: !this.props.relay.variables.isEditMode
        });
    };

    deleteAll = () => {
        clearMyCollection();
        this.toggleEditMode();
        this.props.relay.setVariables({
            objectsIds: [],
            designersIds: [],
            producersIds: [],
        });
    };

    deleteObject = (id) => {
        removeFromMyCollection('objects', id);
        this.props.relay.setVariables({
            objectsIds: getMyCollection().objects
        });
        this.updateView();
    };

    deleteDesigner = (id) => {
        removeFromMyCollection('designers', id);
        this.props.relay.setVariables({
            designersIds: getMyCollection().designers,
        });
        this.updateView();
    };

    deleteProducer = (id) => {
        removeFromMyCollection('producers', id);
        this.props.relay.setVariables({
            producersIds: getMyCollection().producers,
        });
        this.updateView();
    };

    // This is needed because otherwise
    // the component will not update
    updateView = () => {
        this.props.relay.setVariables({
            lastUpdate: Date.now().toString()
        });
    };

    render() {
        const { relay, store } = this.props;
        const isEditMode = relay.variables.isEditMode;
        const { myCollectionObjects, myCollectionDesigners, myCollectionProducers } = store;

        const l = (key) => {
            const str = `${getCurrentLanguage()}.components.MyCollection.${key}`;
            return localize(str);
        };

        return (
            <div styleName="container">
                <DetailHeader
                    relay={ relay }
                    detail={{
                        title: l('title'),
                        icon: <Icon icon="Vitra_Collection.svg" />,
                    }}
                    simple={true}
                />
                <PageHeader
                    store={ store }
                    title={ l('title') }
                    icon={ <Icon icon="Vitra_Collection.svg" /> }
                />
                {
                    isMyCollectionEmpty() ? null : (
                        <MyCollectionToolbar
                            lang={ getCurrentLanguage() }
                            isEditMode={ this.props.relay.variables.isEditMode }
                            toggleEditMode={ this.toggleEditMode }
                            deleteAll={ this.deleteAll }
                        />
                    )
                }
                <div className="page-content">
                    <MyCollectionObjects
                        objects={ myCollectionObjects.edges }
                        title={ l('objects') }
                        deleteEntry={ isEditMode ? this.deleteObject : null }
                    />
                    <MyCollectionPersons
                        persons={ myCollectionDesigners.edges }
                        title={l('designers')}
                        deleteEntry={ isEditMode ? this.deleteDesigner : null }
                    />
                    <MyCollectionPersons
                        persons={ myCollectionProducers.edges }
                        title={l('producers')}
                        deleteEntry={ isEditMode ? this.deleteProducer : null }
                    />
                </div>
            </div>
        )
    }
}

export default MyCollection;


// WEBPACK FOOTER //
// ./app/components/MyCollection/MyCollection.jsx